import { provideHttpClient } from '@angular/common/http';
import {
  type ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { Router } from '@angular/router';
import { createErrorHandler, TraceService } from '@sentry/angular';

import { ConfiguredRoutes } from './app.routes';

export const AppConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useValue: createErrorHandler() },
    { deps: [Router], provide: TraceService },
    provideAppInitializer(() => {
      inject(TraceService);
    }),
    provideBrowserGlobalErrorListeners(),
    provideRouter(ConfiguredRoutes, withComponentInputBinding()),
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
        includeHeaders: ['ETag', 'Cache-Control', 'Authorization'],
        includePostRequests: false,
        includeRequestsWithAuthHeaders: true,
      }),
    ),
    provideHttpClient(),
  ],
};
